// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Bv8I","icon":"styles_icon__17aE9"};